import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { alpha, makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    menuItem: {
        fontSize: pxToRem(16),
        '&:hover': {
            backgroundColor: alpha('#29e3bf', 0.2),
            cursor: 'pointer',
        },
    },
}))

export enum ListingStatus {
    PremiumReview = 'Premium Review',
    PremiumReviewBPMSubmitted = 'Premium Review - BPM Submitted',
    PremiumMasterSpecReview = 'Premium MasterSpec Review',
    PremiumMasterSpecReviewBPMSubmitted = 'Premium MasterSpec Review - BPM Submitted',
    ProprietaryReview = 'Proprietary Review',
    ProprietaryReviewBPMSubmitted = 'Proprietary Review - BPM Submitted',
    Completed = 'Completed',
    Deprecated = 'Deprecated',
}

export interface ListingStatusVariantProps {
    onChange?: (value: string) => void
    hideDeprecated?: boolean
}

const ListingStatusVariant: React.FC<ListingStatusVariantProps> = ({
    onChange,
    hideDeprecated,
}) => {
    const classes = useStyles()

    const handleChange = (value: string) => () => {
        onChange?.(value)
    }

    return (
        <List data-testid={'optionList'}>
            {Object.values(ListingStatus).map(
                (status: ListingStatus, index: number) => {
                    return (
                        (status !== ListingStatus.Deprecated ||
                            !hideDeprecated) && (
                            <ListItem
                                key={`${index}ListingStatus`}
                                className={classes.menuItem}
                                onClick={handleChange(status)}
                                data-testid={`${index}ListingStatus`}
                            >
                                {status}
                            </ListItem>
                        )
                    )
                }
            )}
        </List>
    )
}

export default ListingStatusVariant
